// DS: CR58B
/** An image link in card form that displays art and title
 *  associated with a topic, used in SISU onboarding.
 */ import React from 'react';
import classnames from 'classnames';
import BiDiv from '@wix/da-bi/pkg/Components/BiDiv';
import Checkbox from '@wix/da-ds/pkg/Checkbox';
import DeviationDumbo from '../DeviationViews/Dumbo';
import { BiData } from '@wix/da-bi/pkg/events';
import s from './OnboardingTopicCard.scss';
const OnboardingTopicCard = (props)=>{
    const { onClick, name, coverDeviation, width, className, isSelected, typeId, itemId, rank } = props;
    if (!onClick || !name || !width) {
        return null;
    }
    const linkStyles = {
        width,
        height: width
    };
    return /*#__PURE__*/ React.createElement(BiDiv, {
        style: linkStyles,
        className: classnames(s['root'], className, !coverDeviation && s['missing-bg'], isSelected && s['selected']),
        biData: BiData({
            evid: 236,
            view: 'login',
            component: 'onboarding',
            typeid: typeId !== null && typeId !== void 0 ? typeId : 0,
            itemid: itemId !== null && itemId !== void 0 ? itemId : 0,
            topic: name,
            rank: rank !== null && rank !== void 0 ? rank : 0,
            is_selected: isSelected ? 0 : 1,
            deviationid: coverDeviation ? coverDeviation.deviationId : 0
        }),
        onClick: ()=>onClick(name, itemId)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['deviation-wrapper'],
        style: {
            width,
            height: width
        }
    }, coverDeviation && /*#__PURE__*/ React.createElement(DeviationDumbo, {
        className: s['deviation'],
        deviation: coverDeviation,
        key: coverDeviation.title,
        width: width,
        height: width
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['overlay']
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['name']
    }, name), isSelected && /*#__PURE__*/ React.createElement(Checkbox, {
        className: s['selected-tick'],
        isChecked: true
    }));
};
OnboardingTopicCard.displayName = 'OnboardingTopicCard';
export default OnboardingTopicCard;
